import React, { useEffect, useState } from 'react';

const Hero = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const companies = [
    {
      name: 'NCAR',
      color: '#0066CC',
      icon: (
        <svg className="w-6 h-6" viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"/>
        </svg>
      )
    },
    {
      name: 'UCAR',
      color: '#00A86B',
      icon: (
        <svg className="w-6 h-6" viewBox="0 0 24 24" fill="currentColor">
          <circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" strokeWidth="2"/>
          <path d="M12 6v6l4 2"/>
        </svg>
      )
    },
    {
      name: 'NOAA',
      color: '#003087',
      icon: (
        <svg className="w-6 h-6" viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z"/>
        </svg>
      )
    },
    {
      name: 'NSF',
      color: '#2E86AB',
      icon: (
        <svg className="w-6 h-6" viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
        </svg>
      )
    },
    {
      name: 'NASA',
      color: '#E03C31',
      icon: (
        <svg className="w-6 h-6" viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-5.5-2.5l7.51-3.49L17.5 6.5 9.99 9.99 6.5 17.5zm5.5-6.6c.61 0 1.1.49 1.1 1.1s-.49 1.1-1.1 1.1-1.1-.49-1.1-1.1.49-1.1 1.1-1.1z"/>
        </svg>
      )
    },
  ];

  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
      style={{ background: 'linear-gradient(180deg, #FAF7F2 0%, #F5F0EB 100%)' }}
    >
      {/* Background noise texture */}
      <div
        className="absolute inset-0 opacity-[0.03] pointer-events-none"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.8' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noise)'/%3E%3C/svg%3E")`,
        }}
      />

      {/* Background gradient blobs - COLORFUL */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        {/* Coral/Pink blob - top left */}
        <div
          className="absolute -top-32 -left-32 w-[700px] h-[700px] rounded-full animate-pulse-slow"
          style={{
            background: 'radial-gradient(circle, rgba(255,150,150,0.55) 0%, rgba(255,182,193,0.3) 40%, transparent 70%)',
          }}
        />
        {/* Teal/Cyan blob - top right */}
        <div
          className="absolute -top-20 -right-32 w-[650px] h-[650px] rounded-full"
          style={{
            background: 'radial-gradient(circle, rgba(72,219,200,0.5) 0%, rgba(129,230,217,0.25) 40%, transparent 70%)',
          }}
        />
        {/* Purple/Lavender blob - middle right */}
        <div
          className="absolute top-1/3 -right-20 w-[400px] h-[400px] rounded-full"
          style={{
            background: 'radial-gradient(circle, rgba(196,181,253,0.4) 0%, transparent 60%)',
          }}
        />
        {/* Blue blob - bottom right */}
        <div
          className="absolute bottom-10 right-20 w-[500px] h-[500px] rounded-full"
          style={{
            background: 'radial-gradient(circle, rgba(147,197,253,0.35) 0%, transparent 60%)',
          }}
        />
        {/* Warm peach blob - bottom left */}
        <div
          className="absolute bottom-0 -left-32 w-[500px] h-[500px] rounded-full"
          style={{
            background: 'radial-gradient(circle, rgba(253,186,140,0.35) 0%, transparent 60%)',
          }}
        />
        {/* Subtle yellow accent - center */}
        <div
          className="absolute top-1/2 left-1/3 w-[300px] h-[300px] rounded-full"
          style={{
            background: 'radial-gradient(circle, rgba(253,224,71,0.15) 0%, transparent 60%)',
          }}
        />

        {/* Decorative circles */}
        <div className="absolute top-1/4 right-24 w-40 h-40 border border-teal-300/40 rounded-full" />
        <div className="absolute bottom-1/3 left-20 w-28 h-28 border border-pink-300/40 rounded-full" />
        <div className="absolute top-1/3 left-1/4 w-20 h-20 border border-purple-300/30 rounded-full" />
      </div>

      {/* Floating Social Icons - Left Side */}
      <div
        className={`fixed left-6 top-1/2 -translate-y-1/2 z-20 hidden lg:flex flex-col gap-4 transition-all duration-700 delay-500 ${
          isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-4'
        }`}
      >
        <a href="https://www.linkedin.com/in/ishita-srivastava-8aa66899/" target="_blank" rel="noopener noreferrer" className="social-icon hover:text-[#0A66C2] hover:border-[#0A66C2]" title="LinkedIn">
          <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
            <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
          </svg>
        </a>
        <a href="https://github.com/ishita9" target="_blank" rel="noopener noreferrer" className="social-icon hover:text-[#0066CC] hover:border-[#0066CC] relative group" title="GitHub (NCAR)">
          <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
            <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/>
          </svg>
          <span className="absolute -bottom-1 -right-1 w-3 h-3 bg-[#0066CC] rounded-full text-[6px] text-white flex items-center justify-center font-bold">N</span>
        </a>
        <a href="https://github.com/VectorWorkX" target="_blank" rel="noopener noreferrer" className="social-icon hover:text-[#8B5CF6] hover:border-[#8B5CF6] relative group" title="GitHub (Personal)">
          <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
            <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/>
          </svg>
          <span className="absolute -bottom-1 -right-1 w-3 h-3 bg-[#8B5CF6] rounded-full text-[6px] text-white flex items-center justify-center font-bold">P</span>
        </a>
        <a href="https://x.com/ishitasri961992" target="_blank" rel="noopener noreferrer" className="social-icon hover:text-[#1DA1F2] hover:border-[#1DA1F2]" title="X (Twitter)">
          <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
            <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
          </svg>
        </a>
        <a href="https://scholar.google.com/citations?user=xY8c1x8AAAAJ&hl=en" target="_blank" rel="noopener noreferrer" className="social-icon hover:text-[#4285F4] hover:border-[#4285F4]" title="Google Scholar">
          <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
            <path d="M5.242 13.769L0 9.5 12 0l12 9.5-5.242 4.269C17.548 11.249 14.978 9.5 12 9.5c-2.977 0-5.548 1.748-6.758 4.269zM12 10a7 7 0 1 0 0 14 7 7 0 0 0 0-14z"/>
          </svg>
        </a>
      </div>

      {/* Main Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-24 pb-16">
        <div className="flex flex-col items-center">

          {/* Photo Section */}
          <div
            className={`relative mb-10 transition-all duration-700 ${
              isVisible ? 'opacity-100 scale-100' : 'opacity-0 scale-95'
            }`}
          >
            {/* Profile Image */}
            <div className="relative w-72 h-80 md:w-80 md:h-[380px]">
              <img
                src="/profile.png"
                alt="Ishita Srivastava"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          {/* Name and Title */}
          <div className="text-center mb-16">
            <h1
              className={`text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-display font-bold mb-4 transition-all duration-700 delay-200 ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
            >
              <span className="bg-gradient-to-r from-gray-900 via-gray-800 to-gray-900 bg-clip-text text-transparent">
                Ishita Srivastava
              </span>
            </h1>
            <p
              className={`text-base md:text-lg tracking-[0.25em] uppercase font-medium transition-all duration-700 delay-300 ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
            >
              <span className="bg-gradient-to-r from-teal-600 via-cyan-600 to-purple-600 bg-clip-text text-transparent">
                AI Engineer
              </span>
              <span className="text-gray-400 mx-3">//</span>
              <span className="bg-gradient-to-r from-pink-500 via-orange-500 to-amber-500 bg-clip-text text-transparent">
                Senior Software Engineer
              </span>
            </p>
          </div>

          {/* Company Logos - COLORFUL */}
          <div
            className={`transition-all duration-700 delay-500 ${
              isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
            }`}
          >
            <div className="flex flex-wrap items-center justify-center gap-6 md:gap-10">
              {companies.map((company, index) => (
                <div
                  key={company.name}
                  className="flex items-center gap-2 transition-all duration-300 group cursor-pointer"
                  style={{ animationDelay: `${0.6 + index * 0.1}s` }}
                >
                  <span
                    className="transition-colors duration-300"
                    style={{ color: company.color }}
                  >
                    {company.icon}
                  </span>
                  <span
                    className="text-lg md:text-xl font-bold tracking-wide transition-colors duration-300"
                    style={{ color: company.color }}
                  >
                    {company.name}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
